import React, { useEffect } from 'react';
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';
import { LoadingPage } from 'components/loading';
import { routes } from 'config';
import { AdvocacyProvider } from 'contexts/advocacy/advocacy.context';
import { useAdvocacyContext } from 'contexts/advocacy';
import { Message } from './message';
import { Address } from './address';
import { Success } from './success';

export const AdvocacyPageInternal = () => {
  const { utilityAccountId } = useParams<{ utilityAccountId?: string }>();
  const history = useHistory();
  const location = useLocation();
  const { campaign, representatives } = useAdvocacyContext();

  const {
    advocacy,
    advocacyAddress,
    advocacySuccess,
    advocacyMessage,
    dashboard,
  } = routes({ utilityAccountId });

  useEffect(() => {
    if (location.pathname === advocacy) {
      if (representatives) {
        history.replace(advocacyMessage);
      } else {
        history.replace(advocacyAddress);
      }
    } else if (
      [advocacyMessage, advocacySuccess].includes(location.pathname) &&
      !representatives
    ) {
      history.replace(advocacyAddress);
    }
  }, [
    representatives,
    location.pathname,
    history,
    advocacy,
    advocacyMessage,
    advocacyAddress,
    advocacySuccess,
  ]);

  useEffect(() => {
    if (!campaign) history.replace(dashboard);
  }, [campaign, history, dashboard]);

  return <LoadingPage />;
};

export const Advocacy = () => {
  const routeTemplates = routes();

  return (
    <AdvocacyProvider>
      <Switch>
        <Route path={routeTemplates.advocacyAddress} component={Address} />
        <Route path={routeTemplates.advocacyMessage} component={Message} />
        <Route path={routeTemplates.advocacySuccess} component={Success} />
        <Route
          path={routeTemplates.advocacy}
          component={AdvocacyPageInternal}
        />
        <Redirect to={routeTemplates.advocacyAddress} />
      </Switch>
    </AdvocacyProvider>
  );
};
